import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerGlobalConfirmDeleteDialogProviderProviderResourceBundleEn(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      modal: {
        GlobalConfirmDeleteDialogProvider: {
          cancel: 'Cancel',
          delete: 'Delete',
          message: 'Do you really want to delete "{{ name }}"?',
          title: 'Confirm deletion'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
